import React from 'react';
import { Grid, Button } from 'semantic-ui-react'
class Table extends React.Component {

state = {

}

cancel() {
  this.props.handleClose();
}

render() {
  return (
    <div>
      {this.props.data.map((z) => {
        if (z.partno == this.props.editPartno) {
          return (
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                vinoth kumar
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <Button onClick={this.cancel.bind(this)}>CANCEL</Button>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <Button>SAVE</Button>
              </Grid.Column>
            </Grid>
          );
        }
      })}
    </div>
  );
}
}

export default Table;
